import { jwtResetPasswordUrl } from "../Common/endpoints";
import { NicheForgotPassword } from "niche-ui-component";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Col, Row } from "antd";
import { useOrganization } from "../../OrganizationProvider";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const organization = useOrganization();

  const handleSubmit = (response) => {
    toast.success(response?.data?.message);
    navigate("/");
  };

  return (
    <Row justify="center" className="mt1">
      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
        <Row>
          <Col span={24}>
            <img
              src={`${organization.s3BucketBaseUrl}/OuterLogo.svg`}
              alt="Logo"
            />
          </Col>
        </Row>

        <Row className="mt2">
          <Col className="h1-header">Forgot Password</Col>
        </Row>

        <Row className="mt3 mb2">
          <Col span={24}>
            <NicheForgotPassword
              handleSubmit={handleSubmit}
              url={jwtResetPasswordUrl}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ForgotPassword;
